import type { AxiosInstance, AxiosRequestConfig } from "axios";
import type * as Path from "./paths";
import type {
  OperationResponse,
  Parameters,
  UnknownParamsObject,
} from "../../common";
import { omitPathParameters, replacePathParameters } from "../../utils";

interface OperationMethods {
  "getList"(
    parameters?: Parameters<Path.GetList.QueryParameters> | null,
    data?: any,
    config?: AxiosRequestConfig,
  ): OperationResponse<Path.GetList.Responses.$200>;
  "getBalance"(
    parameters?: Parameters<UnknownParamsObject>,
    data?: any,
    config?: AxiosRequestConfig,
  ): OperationResponse<Path.GetBalance.Responses.$200>;
}

export const getBillOperations = (client: AxiosInstance) => {
  const getList: OperationMethods["getList"] = (parameters, data, config) => {
    const url = "/account/balance/list";
    return client.get(replacePathParameters(url, parameters), {
      params: omitPathParameters(parameters, url),
      data: data,
      ...config,
    });
  };
  const getBalance: OperationMethods["getBalance"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/account/balance";
    return client.get(replacePathParameters(url, parameters), {
      params: omitPathParameters(parameters, url),
      data: data,
      ...config,
    });
  };
  return {
    getList,
    getBalance,
  };
};
